import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(() => ({
  tooltipContent: {
    maxWidth: 360,
    maxHeight: 320,
    overflowY: 'auto',
    whiteSpace: 'normal',
    padding: 4,
  },
  note: {
    '& + &': {
      marginTop: 12,
      paddingTop: 8,
      borderTop: '1px solid rgba(255, 255, 255, 0.35)',
    },
    '& h4': {
      margin: 0,
      lineHeight: 1.5,
    },
    '& p': {
      margin: 0,
    },
  },
  viewMore: {
    marginTop: 8,
  },
  fakeLink: {
    '&:hover': {
      textDecoration: 'underline',
    },
  },
}));
